import { render, staticRenderFns } from "./NavTags.vue?vue&type=template&id=0c88ef6a&scoped=true"
import script from "./NavTags.vue?vue&type=script&lang=js"
export * from "./NavTags.vue?vue&type=script&lang=js"
import style0 from "./NavTags.vue?vue&type=style&index=0&id=0c88ef6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c88ef6a",
  null
  
)

export default component.exports